var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter_24 @ settings"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Icon Color"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24234 8.89998C6.62102 10.061 7.71252 10.9 8.99998 10.9C10.2874 10.9 11.3789 10.061 11.7576 8.89998C14.5051 8.89997 17.2525 8.89998 20 8.89998C20.497 8.89998 20.9 8.49703 20.9 7.99998C20.9 7.50292 20.497 7.09998 20 7.09998C17.2525 7.09998 14.5051 7.09998 11.7576 7.09998C11.7479 7.06961 11.7609 7.11007 11.7576 7.09998C11.3789 5.93893 10.2874 5.09998 8.99998 5.09998C7.71252 5.09998 6.62102 5.93894 6.24234 7.09998C5.49489 7.09998 4.74743 7.09998 3.99998 7.09998C3.50292 7.09998 3.09998 7.50292 3.09998 7.99998C3.09998 8.49703 3.50292 8.89998 3.99998 8.89998C4.74743 8.89998 5.49489 8.89997 6.24234 8.89998ZM8.99998 6.89998C8.39246 6.89998 7.89998 7.39246 7.89998 7.99998C7.89998 8.60749 8.39246 9.09998 8.99998 9.09998C9.60749 9.09998 10.1 8.60749 10.1 7.99998C10.1 7.39246 9.60749 6.89998 8.99998 6.89998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09998 16C3.09998 15.5029 3.50292 15.1 3.99998 15.1C6.74743 15.1 9.49489 15.1 12.2423 15.1C12.621 13.9389 13.7125 13.1 15 13.1C16.2874 13.1 17.3789 13.9389 17.7576 15.1C17.7576 15.1 19.4786 15.1 20 15.1C20.497 15.1 20.9 15.5029 20.9 16C20.9 16.497 20.497 16.9 20 16.9C19.7777 16.9 17.7576 16.9 17.7576 16.9C17.3789 18.061 16.2874 18.9 15 18.9C13.7125 18.9 12.621 18.061 12.2423 16.9C9.49489 16.9 6.74743 16.9 3.99998 16.9C3.50292 16.9 3.09998 16.497 3.09998 16ZM13.9 16C13.9 15.3925 14.3925 14.9 15 14.9C15.6075 14.9 16.1 15.3925 16.1 16C16.1 16.6075 15.6075 17.1 15 17.1C14.3925 17.1 13.9 16.6075 13.9 16Z",
    fill: "black"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.fe73ea5ef4c9fff1814f2123e2971185.svg";
export { ForwardRef as ReactComponent };